import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  CardTitle,
  // Form,
  Container,
  Col,
  // Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row
} from "reactstrap";

import { Link } from "react-router-dom";

import axios from "axios";

import { Button as Buttton } from "components";

// import nowLogo from "assets/img/nadu-logo-full.png";
import nowLogo from "assets/img/PIALPA.png";

import bgImage1 from "assets/img/minibg/bg1.jpg";
import bgImage2 from "assets/img/minibg/bg2.jpg";
import bgImage3 from "assets/img/minibg/bg3.jpg";
import bgImage4 from "assets/img/minibg/bg4.jpg";
import bgImage5 from "assets/img/minibg/bg5.jpg";
import bgImage6 from "assets/img/minibg/bg6.jpg";
import bgImage7 from "assets/img/minibg/bg7.jpg";
import bgImage8 from "assets/img/minibg/bg8.jpg";
import bgImage9 from "assets/img/minibg/bg9.jpg";
import bgImage10 from "assets/img/minibg/bg10.jpg";
import bgImage11 from "assets/img/minibg/bg11.jpg";
import bgImage12 from "assets/img/minibg/bg12.jpg";
import Cookies from "universal-cookie";
import * as XLSX from 'xlsx';
import { Form, Input, Button, DatePicker, Space, Radio, Select } from 'antd';
import { DeleteOutlined, UserOutlined } from '@ant-design/icons'; // Importa el ícono de la papelera


// Importa Day.js
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;

const MAX_PERSONS = 6;
const tarifas = "/assets/tarifas.xlsx";
// import FaceDetection from "views/FaceDetection/FaceDetection.jsx";
const cookies = new Cookies();

// const API = "https://mi-tienda.nadunet.es/api/rest/";
const API = !window.location.host.includes("localhost") ? "https://" + window.location.host + "/api/rest/" : "https://oficina.nadunet.es/api/rest/";
const GET_USERNAME_URL = "nadulogin_resources/get_username.json";
const DO_LOGIN_URL = "user/login";
const LOGIN_URL = "nadulogin_resources/login";
const GET_TOKEN_URL = "user/token";
const DO_LOGOUT_URL = "user/logout";
const bgs = [
  bgImage1,
  bgImage2,
  bgImage3,
  bgImage4,
  bgImage5,
  bgImage6,
  bgImage7,
  bgImage8,
  bgImage9,
  bgImage10,
  bgImage11,
  bgImage12
];
const recuperarPassStyle = {
  textAlign: "center"
};
const EMPRESA = "empresa";
const PARTICULAR = "particular";
const { Option } = Select;
const randomBgNumber = Math.floor(Math.random()*(11-10+1)+10);
const randomBg = bgs[randomBgNumber];
const fields = {
  login: "dniField",
  pass: "passField"
};
const zero_state = {
  fields: fields,
  [fields.login]: "",
  [fields.pass]: "",
  username: "",
  loginError: false,
  isLogging: false,
  randomBg: randomBg,
  persons: [],
  formData: {
    name: '',
    dob: [],
  },
  customerType: null,
  tipoCliente: null,
  totals: null,
  welcomeMessage: true,
  moreInfo: false,
  postalCode: null,
  sentInsurance: [],
  selectedPlan: null,
  selectedContact: null
};
class LoginPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = zero_state;

    this.startLogin = this.startLogin.bind(this);
    this.getUsername = this.getUsername.bind(this);
    this.doLogin = this.doLogin.bind(this);
    this.getLoginButton = this.getLoginButton.bind(this);
    this.handleLoginError = this.handleLoginError.bind(this);
    this.cleanSession = this.cleanSession.bind(this);
    this.miniLogout = this.miniLogout.bind(this);
    this.showLoginError = this.showLoginError.bind(this);
    this.fileInputRef = React.createRef();
    this.validateCustomerType = this.validateCustomerType.bind(this);
    this.validatePostalCode = this.validatePostalCode.bind(this);
    this.validateCustomers = this.validateCustomers.bind(this);
    this.buildContent = this.buildContent.bind(this);
    this.buildCustomerType = this.buildCustomerType.bind(this);
    this.buildPostalCode = this.buildPostalCode.bind(this);
    this.buildCustomers = this.buildCustomers.bind(this);
    this.validateCalculation = this.validateCalculation.bind(this);
    this.calculate = this.calculate.bind(this);
    this.showCalculations = this.showCalculations.bind(this);
    this.sendInsuranceQuote = this.sendInsuranceQuote.bind(this);
  }
  componentDidMount() {
    // Definir la ubicación del archivo local aquí
    const fileLocation = tarifas;
    console.log("fileLocation", fileLocation);

    this.loadFile(fileLocation);
  }
  loadFile = (fileLocation) => {
    fetch(fileLocation)
      .then((response) => response.arrayBuffer())
      .then((data) => {
        this.setState({ excel: data });
      })
      .catch((error) => {
        console.error('Error loading the Excel file:', error);
      });
  };
  getLoginButton() {
    let loginButton = null;

    if(this.state.isLogging){
      loginButton = 
        <div>
          <i className="now-ui-icons arrows-1_refresh-69 spin" /> Calculando
        </div>;
    }else{
      loginButton = "Calcular precios";
    }

    return loginButton;
  }
  startLogin() {
    alert("Usuario: " + this.state.dniField +"\nContraseña: " + this.state.passField);
    this.getUsername();
  }
  handleChange(field, event) {
    ////////console.log("Field name: " + field);
    ////////console.log("Field value: " + event.target.value);
    this.setState({ [field]: event.target.value });
  }
  getUsername(option) {
    if (this.state.isLogging && !option) return;
    /* //////console.log("################## GET USERNAME ################"); */

    this.setState({
      isLogging: true
    });

    let request = {
      dni: this.state.dniField,
      password: this.state.passField
    };
    /* //////console.log(request); */
    //this.setState({ isLoading: true });
    axios.post(API + GET_USERNAME_URL, request,{withCredentials: false})
      .then(result => {
        /* //////console.log("################## RESPUESTA ################");
        //////console.log(result); */
        if(result !== null && result.data.length > 0 && result.data[0] !== ""){
          this.setState({
            username: result.data[0],
            loginError: false
          });
          this.doLogin();
        }else{
          this.setState({
            loginError: true,
            isLogging: false
          });
          this.showLoginError();
        }
      })
      .catch((error) => {
        // Error 😨
        if (error.response) {
            /*
              * The request was made and the server responded with a
              * status code that falls out of the range of 2xx
              */
            /* //////console.log(error.response.data);
            //////console.log(error.response.status);
            //////console.log(error.response.headers); */

            this.handleLoginError(error.response.status);

            /* this.setState({
              error,
              isLogging: false
            }); */
        } else if (error.request) {
            /*
              * The request was made but no response was received, `error.request`
              * is an instance of XMLHttpRequest in the browser and an instance
              * of http.ClientRequest in Node.js
              */
            /* //////console.log(error.request); */
            this.handleLoginError(666);
            /* this.setState({
              error,
              isLogging: false
            }); */
        } else {
            // Something happened in setting up the request and triggered an Error
            /* //////console.log('Error', error.message); */
            this.setState({
              error,
              isLogging: false
            });
        }
        /* //////console.log(error.config); */
      });
  }
  showLoginError() {
    var options = {
      place: "tr",
      message: "Credenciales incorrectas",
      type: "danger",
      icon: "now-ui-icons objects_key-25",
      autoDismiss: 3
    };
    this.props.showNotification(options);
  }
  doLogin(option) {
    if (this.state.isLogging && !option) return;
    /* //////console.log("################## DO LOGIN ################"); */
    this.setState({
      isLogging: true
    });

    let request = {
      dni: this.state.dniField,
      password: this.state.passField
    };
    // let request = {
    //   username: this.state.dniField,
    //   password: this.state.passField
    // };
    /* //////console.log(request); */
    //this.setState({ isLoading: true });
    axios.post(API + LOGIN_URL, request, {withCredentials: false})
      .then(result => {
        // console.log("################## RESPUESTA LOGIN ################");
        // console.log(result);
        this.setState({
          isLogging: false
        });
        this.props.godMode(result, false, this.state.passField);
      })
      .catch((error) => {
        // Error 😨
        if (error.response) {
            /*
              * The request was made and the server responded with a
              * status code that falls out of the range of 2xx
              */
            /* //////console.log(error.response.data);
            //////console.log(error.response.status);
            //////console.log(error.response.headers); */

            this.handleLoginError(error.response.status);

            /* this.setState({
              error,
              isLogging: false
            }); */
        } else if (error.request) {
            /*
              * The request was made but no response was received, `error.request`
              * is an instance of XMLHttpRequest in the browser and an instance
              * of http.ClientRequest in Node.js
              */
            /* //////console.log(error.request); */
            this.handleLoginError(666);
            /* this.setState({
              error,
              isLogging: false
            }); */
        } else {
            // Something happened in setting up the request and triggered an Error
            /* //////console.log('Error', error.message); */
            this.setState({
              error,
              isLogging: false
            });
        }
        /* //////console.log(error.config); */
      });
  }
  handleLoginError(error) {
    //////console.log("#################### HANDLE ERROR ##################");
    //////console.log(error);
    switch (error) {
      case 401:
        this.cleanSession();
        this.getUsername(error);
        break;
      case 500:
        this.getUsername(error);
        break;
      case 666:
        this.getUsername(error);
        break;
      default:
        break;
    }
  }
  cleanSession() {
    let request = {};
    let newToken = "";

    //this.setState({ isLoading: true });
    axios.post(API + GET_TOKEN_URL, request, {withCredentials: true})
      .then(result => {
        //////console.log("################## RESPUESTA GET TOKEN ################");
        //////console.log(result);
        newToken = result.data.token;
        this.miniLogout(newToken);
      })
      .catch((error) => {
        // Error 😨
        if (error.response) {
            /*
              * The request was made and the server responded with a
              * status code that falls out of the range of 2xx
              */
            //////console.log(error.response.data);
            //////console.log(error.response.status);
            //////console.log(error.response.headers);

            this.handleLoginError(error.response.status);

            /* this.setState({
              error,
              isLogging: false
            }); */
        } else if (error.request) {
            /*
              * The request was made but no response was received, `error.request`
              * is an instance of XMLHttpRequest in the browser and an instance
              * of http.ClientRequest in Node.js
              */
            //////console.log(error.request);
            this.handleLoginError(666);
            /* this.setState({
              error,
              isLogging: false
            }); */
        } else {
            // Something happened in setting up the request and triggered an Error
            //////console.log('Error', error.message);
            this.setState({
              error,
              isLogging: false
            });
        }
        //////console.log(error.config);
      });
  }
  miniLogout(newToken) {
    let request = {};
    let queryHeaders = {
      headers:{
        "X-CSRF-Token": newToken,
        "Content-Type": "application/json",
        "Accept": "application/json"
      }
    };
    axios
      .post(API + DO_LOGOUT_URL, request, {
        headers: queryHeaders.headers,
        withCredentials: true
      })
      .then(result => {
        //////console.log("################## RESPUESTA LOGOUT ################");
        //////console.log(result);
        
        if(result.data[0]) {
          this.getUsername();
        } else {
          this.cleanSession();
        }
      })
      .catch((error) => {
        // Error 😨
        if (error.response) {
            /*
              * The request was made and the server responded with a
              * status code that falls out of the range of 2xx
              */
            //////console.log(error.response.data);
            //////console.log(error.response.status);
            //////console.log(error.response.headers);

            this.handleLoginError(error.response.status);

            /* this.setState({
              error,
              isLogging: false
            }); */
        } else if (error.request) {
            /*
              * The request was made but no response was received, `error.request`
              * is an instance of XMLHttpRequest in the browser and an instance
              * of http.ClientRequest in Node.js
              */
            //////console.log(error.request);
            this.handleLoginError(666);
            /* this.setState({
              error,
              isLogging: false
            }); */
        } else {
            // Something happened in setting up the request and triggered an Error
            //////console.log('Error', error.message);
            this.setState({
              error,
              isLogging: false
            });
        }
        //////console.log(error.config);
      });
  }
  randomIntFromInterval(min,max) {
      return Math.floor(Math.random()*(max-min+1)+min);
  }
  onFinish = (date) => {
    const { persons, formData } = this.state;
    const newPerson = {
      date: formData.date //dayjs(values.dob).format('DD/MM/YYYY'),
    };
    this.setState({
      persons: [...persons, newPerson],
      formData: {
        date: null,
      },
    });
  };

  handleRemovePerson = (index) => {
    const { persons } = this.state;
    const updatedPersons = persons.filter((_, i) => i !== index);
    this.setState({ persons: updatedPersons });
  };
  validateFormData(formData) {
    let result = true;
    if (!formData) return false;
    if (!formData.date) return false;
    return result;
  }
  validateCustomerType() {
    if (this.state.tipoCliente == null) return false;
    return true;
  }
  validatePostalCode() {
    if (!this.state.postalCode) return false;
    // Expresión regular para validar que hay exactamente 5 dígitos
    const postalCodePattern = /^\d{5}$/;
    let postalCode = this.state.postalCode;
  
    if (postalCode && postalCodePattern.test(postalCode)) {
      return true;
    } else {
      return false;
    }
  }
  validateCustomers() {
    let customers = this.state.persons;
    if (!customers) return false;
    if (customers < 1) return false;
    return true;
  }
  getCustomerTypeClass() {
    let ready = this.validateCustomerType();
    return ready ? "ready" : "";
  }
  getPostalCodeClass() {
    let ready = this.validatePostalCode();
    let result = ready ? "ready" : "error";
    result = this.validateCustomerType() ? result : "";
    return result;
  }
  getCustomersClass() {
    let ready = this.validateCustomers();
    let result = ready ? "ready" : "error";
    result = this.validateCustomerType() && this.validatePostalCode() ? result : "";
    return result;
  }
  // Función para manejar el cambio de selección
  handleTipoClienteChange = (value) => {
    this.setState({ tipoCliente: value });
  };
  // Función para manejar el cambio de código postal
  handlePostalCodeChange = (e) => {
    this.setState({ postalCode: e.target.value });
  };
  // Función para manejar el cambio de nombre completo
  handleFullnameChange = (e) => {
    this.setState({ fullname: e.target.value });
  };
  // Función para manejar el cambio de móvil/correo
  handleMobileChange = (e) => {
    this.setState({ mobile: e.target.value });
  };
  buildCustomerType() {
    return (
      <Card className="txt-black">
        <CardBody>
          <h5>
            Tipo de tomador
          </h5>
          <Select
            placeholder="Elige tipo"
            style={{ width: 200 }}
            value={this.state.tipoCliente} // Asigna el valor seleccionado al estado
            onChange={this.handleTipoClienteChange} // Maneja el cambio de selección
          >
            <Option value={0}>Particular</Option>
            <Option value={1}>Autónomo</Option>
            <Option value={2}>Empresa</Option>
          </Select>
        </CardBody>
      </Card>
    );
  }
  buildPostalCode() {
    let content = null;
    const { persons, formData } = this.state;
    if (this.validateCustomerType()) {
      content = (
        <Card className="txt-black">
          <CardBody>
            <h5>
              Código postal
            </h5>
            <Input
              placeholder="Ejemplo: 12345"
              style={{ width: 200 }}
              value={this.state.postalCode} // Asigna el valor seleccionado al estado
              onChange={this.handlePostalCodeChange} // Maneja el cambio de selección
            />
          </CardBody>
        </Card>
      );
    } else {
      content = (
        <Card className="disabled">
          <CardBody>
            <h5>
              Código postal
            </h5>
          </CardBody>
        </Card>
      );
    }
    return content;
  }
  buildCustomers() {
    let content = null;
    const { formData } = this.state;
    let persons = this.state.persons;
    if (!persons) persons = [];
    if (this.validateCustomerType() && this.validatePostalCode()) {
      content = (
        <div>
          {persons.map((person, index) => (
            <Card key={index}>
              <CardBody>
                <Space>
                  <Button
                    style={{ float: "right" }}
                    danger
                    icon={<DeleteOutlined />} // Agrega el ícono de la papelera
                    onClick={() => this.handleRemovePerson(index)}
                  />
                  <Button type="primary" icon={<UserOutlined />}>{index + 1}</Button>
                    {/* <span>{`Persona ${index + 1}`}</span> */}
                  <span>{person.date.format('DD/MM/YYYY')}</span>
                </Space>
              </CardBody>
            </Card>
          ))}
          {persons.length < MAX_PERSONS && (
            <Card color="primary">
              <CardBody>
                <h5>
                  Añadir asegurados
                </h5>
                <span>Selecciona fecha de nacimiento</span><br />
                <Space direction="vertical">
                  <DatePicker value={formData.date} format="DD/MM/YYYY" onChange={e => {
                    let formData = this.state.formData;
                    formData.date = e;
                    this.setState({ formData: formData });
                  }} />
                  <Buttton color="info" disabled={!this.validateFormData(formData)} onClick={() => this.onFinish(formData)}>
                    Añadir asegurado
                  </Buttton>
                </Space>
              </CardBody>
            </Card>
          )}
        </div>
      );
    } else {
      content = (
        <Card className="disabled">
          <CardBody>
            <h5>
              Añadir asegurados
            </h5>
          </CardBody>
        </Card>
      );
    }
    return content;
  }
  validateCalculation() {
    return this.validateCustomerType() && this.validatePostalCode() && this.validateCustomers();
  }
  calculate() {
    if (!this.validateCalculation()) return;
    this.setState({ isCalculating: true });
    const { tipoCliente, postalCode, persons } = this.state;
    let customerType = tipoCliente;
    let customers = persons.map((person, index) => {
      const now = dayjs();
      const birthDate = dayjs(person.date);
      const ageInMonths = now.diff(birthDate, 'month');
      const ageInYears = Math.round(ageInMonths / 12);
      return ageInYears;
    });
    let data = {
      customerType: customerType,
      postalCode: postalCode,
      province: parseInt(postalCode.slice(0, 2)),
      customers: {
        amount: customers.length,
        list: customers
      }
    };
    console.log("calculate data", data);
    let columns = ["B", "C", "D", "E", "F", "G", "H", "I"];
    const { excel } = this.state;
    const workbook = XLSX.read(excel, { type: 'array' });

    const sheetNameRed = workbook.SheetNames[customerType];
    const worksheetRed = workbook.Sheets[sheetNameRed];
    const sheetNameGreen = workbook.SheetNames[3 + customerType];
    const worksheetGreen = workbook.Sheets[sheetNameGreen];
    const sheetNameBlue = workbook.SheetNames[6 + customerType];
    const worksheetBlue = workbook.Sheets[sheetNameBlue];

    let indexRow = 2 + data.province;
    let indexColumn = "I";
    let indexCell = indexColumn.concat(indexRow);
    console.log("indexCell: " + indexCell);

    let totalRed = 0;
    let totalGreen = 0;
    let totalBlue = 0;
    let redIndex = worksheetRed[indexCell] ? parseFloat(worksheetRed[indexCell].v) : 1;
    console.log("redIndex: " + redIndex);
    let greenIndex = worksheetGreen[indexCell] ? parseFloat(worksheetGreen[indexCell].v) : 1;
    console.log("greenIndex: " + greenIndex);
    let blueIndex = worksheetBlue[indexCell] ? parseFloat(worksheetBlue[indexCell].v) : 1;
    console.log("blueIndex: " + blueIndex);
    let customersList = data.customers.list;
    let customersCount = data.customers.amount;
    customersList.map(customer => {
      let cell = columns[customersCount - 1].concat(customer + 3);
      console.log("cell: " + cell);
      totalRed += worksheetRed[cell] ? worksheetRed[cell].v * redIndex : 0;
      totalGreen += worksheetGreen[cell] ? worksheetGreen[cell].v * greenIndex : 0;
      totalBlue += worksheetBlue[cell] ? worksheetBlue[cell].v * blueIndex : 0;
    });
    let totals = {
      red: totalRed,
      green: totalGreen,
      blue: totalBlue
    };
    console.log("totals: ", totals);
    this.setState({ totals: totals });
    setTimeout(this.showCalculations, 3000);
  }
  showCalculations() {
    this.setState({ isCalculating: false });
  }
  buildContactMethod() {
    const { selectedContact } = this.state;
    if (!selectedContact) return null;
    if (selectedContact == "callme") {
      if (!this.state.contactMe) {
        return (
          <div>
            <h4 className="text-center txt-white">¿Cómo contactamos contigo?</h4>
            <Card className="txt-black">
              <CardBody>
                <h5>
                  Nombre completo
                </h5>
                <Input
                  placeholder="Nombre Apellido1 Apellido2"
                  style={{ width: 200 }}
                  value={this.state.fullname} // Asigna el valor seleccionado al estado
                  onChange={this.handleFullnameChange} // Maneja el cambio de selección
                />
                <h5>
                  Móvil o email
                </h5>
                <Input
                  placeholder="612345678/correo@dominio.es"
                  style={{ width: 200 }}
                  value={this.state.mobile} // Asigna el valor seleccionado al estado
                  onChange={this.handleMobileChange} // Maneja el cambio de selección
                />
              </CardBody>
            </Card>
            <Buttton
              block
              round
              size="lg"
              type="primary"
              color="primary"
              // style={{ background: '#46B98A', borderColor: '#46B98A' }}
              className="mb-3"
              onClick={() => {
                this.setState({ contactMe: true });
                this.sendInsuranceQuote("callme");
              }}
            >
              ¡Contactad conmigo!
            </Buttton>
          </div>
        );
      } else {
        return (
          <div>
            <Card className="txt-black text-center">
              <CardBody>
                <h5>¡Muy pronto contactaremos contigo!</h5>
              </CardBody>
            </Card>
          </div>
        );
      }
    } else {
      const encoded = encodeURI(
        "Quiero información del presupuesto " + this.state.priceNumber
      );
      return (
        <div>
          <h4 className="text-center txt-white">Nº Presupuesto</h4>
          <Card className="txt-black text-center">
            <CardBody>
              <h5>{this.state.priceNumber}</h5>
            </CardBody>
          </Card>
          <h4 className="text-center txt-white">Nuestra info</h4>
          <Card className="txt-black">
            <CardBody>
              <span>¡Gracias por elegir contactar con nosotros, al hacerlo <b>no olvides indicar el número de presupuesto
                que te mostramos justo encima de este mensaje</b>. Puedes contactar con nosotros de las siguientes formas:</span>
              <h5>
                Llamada telefónica
              </h5>
              <a href="tel:664188426"><span>664 188 426</span></a>
              <br />
              <h5>
                WhatsApp
              </h5>
              <a href={"https://wa.me/34664188426/?text=" + encoded}><span>664 188 426</span></a>
              <br />
              <h5>
                Correo electrónico
              </h5>
              <span>pialpa@pialpa.com</span>
            </CardBody>
          </Card>
        </div>
      );
    }
  }
  sendInsuranceQuote(action) {
    console.log("send insurance", this.state);
    let sentInsurance = this.state.sentInsurance;
    console.log("sentInsurance", sentInsurance);
    if (sentInsurance && sentInsurance[action]) {
      console.log("no se envía porque ya se ha enviado (action)", action);
      return;
    }
    sentInsurance[action] = true;
    this.setState({ sentInsurance: sentInsurance });
    let contact_customer = false;
    switch (action) {
      case "icall":
        action = "El cliente nos contactará";
        break;
      case "callme":
        contact_customer = true;
        action = "¡Hay que llamar al cliente!";
        break;
      default:
        action = "El cliente nos contactará";
        break;
    }
    let color = this.state.selectedPlan;
    switch (color) {
      case "green":
        color = "Verde";
        break;
      case "red":
        color = "Roja";
        break;
      case "blue":
        color = "Azul";
        break;
      default:
        color = "No elegida";
        break;
    }
    let customerType = ["Particular", "Autónomo", "Empresa"];
    customerType = customerType[this.state.tipoCliente];
    let persons = this.state.persons;
    let quote = {
      id: this.state.priceNumber,
      price: this.state.totals[this.state.selectedPlan].toFixed(2),
      contact_customer: contact_customer,
      color: color,
      action: action,
      customer_type: customerType,
      postal_code: this.state.postalCode,
      persons: {
        count: persons.length,
        ages: persons.map(person => {
          const now = dayjs();
          const birthDate = dayjs(person.date);
          const ageInMonths = now.diff(birthDate, "month");
          const ageInYears = Math.round(ageInMonths / 12);
          return ageInYears;
        })
      }
    };
    if (contact_customer) {
      quote.contact_info = {
        name: this.state.fullname,
        contact: this.state.mobile
      };
    }
    quote = {
      quote: quote
    };
    axios.post(API + "nadunet_billing_resources/send_insurance_quote", quote, {withCredentials: false})
    .then(result => {
      console.log("respuesta sendInsurance", result);
    })
    .catch((error) => {
      // Error 😨
      console.log("error sendInsurance", error);
    });
  }
  buildContent() {
    if (this.state.isCalculating) {
      return (
        <div>
          <Card color="primary" className="text-center">
            <CardBody>
              <i className="now-ui-icons arrows-1_refresh-69 spin" /> Buscando la mejor tarifa
            </CardBody>
          </Card>
        </div>
      );
    } else {
      if (this.state.totals) {
        const { selectedContact, selectedPlan } = this.state;
        if (this.state.moreInfo) {
          return (
            <div>
              <h4 className="text-center txt-white">¿Qué prefieres?</h4>
              <Card
                color="primary"
                className={
                  "text-center plan " +
                  (selectedContact
                    ? selectedContact === "callme"
                      ? "selected-plan"
                      : "unselected-plan"
                    : "")
                }
                onClick={() => this.setState({ selectedContact: "callme" })}
              >
                <CardBody>{"Que contacten conmigo"}</CardBody>
              </Card>
              <Card
                color="info"
                className={
                  "text-center plan " +
                  (selectedContact
                    ? selectedContact === "icall"
                      ? "selected-plan"
                      : "unselected-plan"
                    : "")
                }
                onClick={() => {
                  this.setState({ selectedContact: "icall" });
                  this.sendInsuranceQuote("icall");
                }}
              >
                <CardBody>{"Llamar yo"}</CardBody>
              </Card>
              {this.buildContactMethod()}
              <h4 className="text-center txt-white">¿Empezamos de nuevo?</h4>
              <Buttton
                block
                round
                size="lg"
                type="default"
                color="default"
                // style={{ background: '#46B98A', borderColor: '#46B98A' }}
                className="mb-3"
                onClick={() => this.setState(zero_state)}
              >
                Volver a empezar
              </Buttton>
            </div>
          );
        }
        return (
          <div>
            <h4 className="text-center txt-white">¡Elige una!</h4>
            <Card
              color="danger"
              className={
                "text-center plan " +
                (selectedPlan
                  ? selectedPlan === "red"
                    ? "selected-plan"
                    : "unselected-plan"
                  : "")
              }
              onClick={() => this.setState({ selectedPlan: "red" })}
            >
              <CardBody>
                <b>{"Tarifa Roja " + this.state.totals.red.toFixed(2).toString().replace(".", ",") + " €/mes"}</b>
              </CardBody>
            </Card>
            <Card
              color="primary"
              className={
                "text-center plan " +
                (selectedPlan
                  ? selectedPlan === "green"
                    ? "selected-plan"
                    : "unselected-plan"
                  : "")
              }
              onClick={() => this.setState({ selectedPlan: "green" })}
            >
              <CardBody>
                <b>{"Tarifa Verde " + this.state.totals.green.toFixed(2).toString().replace(".", ",") + " €/mes"}</b>
              </CardBody>
            </Card>
            <Card
              color="info"
              className={
                "text-center plan " +
                (selectedPlan
                  ? selectedPlan === "blue"
                    ? "selected-plan"
                    : "unselected-plan"
                  : "")
              }
              onClick={() => this.setState({ selectedPlan: "blue" })}
            >
              <CardBody>
                <b>{"Tarifa Azul " + this.state.totals.blue.toFixed(2).toString().replace(".", ",") + " €/mes"}</b>
              </CardBody>
            </Card>
            <Buttton
              block
              disabled={!this.state.selectedPlan}
              round
              size="lg"
              type="primary"
              color="primary"
              // style={{ background: '#46B98A', borderColor: '#46B98A' }}
              className="mb-3"
              onClick={() => {
                let priceNumber = Math.random().toString().slice(2, 7); // Obtiene una cadena aleatoria de 5 caracteres
                this.setState({
                  priceNumber: priceNumber,
                  moreInfo: true 
                });
              }}
            >
              Quiero más información
            </Buttton>
            <h4 className="text-center txt-white">¿Empezamos de nuevo?</h4>
            <Buttton
              block
              round
              size="lg"
              type="default"
              color="default"
              // style={{ background: '#46B98A', borderColor: '#46B98A' }}
              className="mb-3"
              onClick={() => this.setState(zero_state)}
            >
              Volver a empezar
            </Buttton>
            <h4 className="text-center txt-white">Condiciones</h4>
            <Card className="card-login">
              <CardBody>
                <span>
                  <p>Seguro de Salud de <b>Asistencia Médica Hospitalaria y Extrahospitalaria</b>, a través de cuadro médico de ámbito <b>nacional</b>, con elevadas prestaciones y <b>sin copago</b>.</p>

                  <p><b>Asistencia Médica Hospitalaria</b>: Hospitalización en habitación individual en los principales hospitales de su entorno.</p>

                  <p><b>Asistencia Médica Extrahospitalaria</b>: Todas las especialidades. Pediatría, Oncología, Medina interna, Apartado digestivo, Obstetricia y Ginecología, Urología, Rehabilitación, Oftalmología, Cardiología, Análisis clínicos, Alergia, Radiodiagnóstico etc…</p>

                  <p><b>Sin copago</b>: sin cargo alguno por el uso de sus servicios sanitarios del cuadro médico.</p>

                  <p>Las ofertas tienen una validez de 15 días.</p>

                  <p>Primas confirmadas a falta de la aceptación por parte de la compañía al rellenar el cuestionario de salud.</p>
                </span>
              </CardBody>
            </Card>
          </div>
        );
      } else {
        return (
          <div>
            <div className={"form-block " + this.getCustomerTypeClass()}>
              <div className="form-block-number">1</div>
              {this.buildCustomerType()}
            </div>
            <div className={"form-block " + this.getPostalCodeClass()}>
              <div className="form-block-number">2</div>
              {this.buildPostalCode()}
            </div>
            <div className={"form-block " + this.getCustomersClass()}>
              <div className="form-block-number">3</div>
              {this.buildCustomers()}
            </div>
          </div>
        );
      }
    }
  }
  buildCalculator() {

  }
  buildWelcomeMessage() {
    return (
      <Card className="card-login card-plain">
        <CardHeader>
          <div className="logo-container">
            <img src={nowLogo} alt="now-logo" />
          </div>
        </CardHeader>
        <CardBody>
          <Card className="card-login">
            <CardBody>
              <span>
                <p><b>Calcula tu seguro y el de los tuyos con unas simples preguntas y si te interesa estaremos encantados de atenderte.</b></p>

                <p>Seguro de Salud de <b>Asistencia Médica Hospitalaria y Extrahospitalaria</b>, a través de cuadro médico de ámbito <b>nacional</b>, con elevadas prestaciones y <b>sin copago</b>.</p>

                <p><b>Asistencia Médica Hospitalaria</b>: Hospitalización en habitación individual en los principales hospitales de su entorno.</p>

                <p><b>Asistencia Médica Extrahospitalaria</b>: Todas las especialidades. Pediatría, Oncología, Medina interna, Apartado digestivo, Obstetricia y Ginecología, Urología, Rehabilitación, Oftalmología, Cardiología, Análisis clínicos, Alergia, Radiodiagnóstico etc…</p>

                <p><b>Sin copago</b>: sin cargo alguno por el uso de sus servicios sanitarios del cuadro médico.</p>
              </span>
            </CardBody>
          </Card>
        </CardBody>
        <CardFooter className="text-center">
          <Buttton
            block
            round
            size="lg"
            type="primary"
            color="primary"
            // style={{ background: '#46B98A', borderColor: '#46B98A' }}
            className="mb-3"
            onClick={() => this.setState({ welcomeMessage: false })}
          >
            Calcular
          </Buttton>
          {/*<div style={recuperarPassStyle}>
            <Link to="/recuperar">Recuperar contraseña</Link>
          </div>*/}
          {/* this.state.loginError && loginErrorMessage */}
          {/* <div className="pull-right">
            <h6>
              <a href="#pablo" className="link footer-link">
                Need Help?
              </a>
            </h6>
          </div> */}
        </CardFooter>
      </Card>
    );
  }
  buildRender() {
    if (this.state.welcomeMessage) {
      return this.buildWelcomeMessage();
    } else {
      return (
        <Card className="card-login card-plain">
          <CardHeader>
            <div className="logo-container">
              <img src={nowLogo} alt="now-logo" />
            </div>
          </CardHeader>
          <CardBody>{this.buildContent()}</CardBody>
          <CardFooter className="text-center">
            {!this.state.isCalculating && !this.state.totals && <Buttton
              disabled={!this.validateCalculation()}
              block
              round
              size="lg"
              type="primary"
              color="primary"
              // style={{ background: '#46B98A', borderColor: '#46B98A' }}
              className="mb-3"
              onClick={() => this.calculate()}
            >
              {this.getLoginButton()}
            </Buttton>}
            {/*<div style={recuperarPassStyle}>
              <Link to="/recuperar">Recuperar contraseña</Link>
            </div>*/}
            {/* this.state.loginError && loginErrorMessage */}
            {/* <div className="pull-right">
              <h6>
                <a href="#pablo" className="link footer-link">
                  Need Help?
                </a>
              </h6>
            </div> */}
          </CardFooter>
        </Card>
      );
    }
  }
  render() {
    let fields = this.state.fields;
    let loginErrorMessage =    
      <div className="pull-left link footer-link">
        <h6>
            Credenciales incorrectas
        </h6>
      </div>;
    return (
      <div>
        <div className="full-page-content">
          <div className="login-page">
            <Container>
              <Col xs={12} md={8} lg={6} className="ml-auto mr-auto">
                <Form>
                  {this.buildRender()}
                </Form>
              </Col>
            </Container>
          </div>
        </div>
        <div
          className="full-page-background"
          style={{ backgroundImage: "url(" + this.state.randomBg + ")" }}
        />
      </div>
    );
  }
}

export default LoginPage;



// WEBPACK FOOTER //
// ./src/views/Pages/LoginPage.jsx